import { Col, Container, Row, Spinner } from "react-bootstrap";
import LogoHeader from "../logoHeader/logoHeader";

export function HydroSpinner() {

    return (<Container>
        <LogoHeader />
        <Container style={{ height: '100%' }}>
            <Row style={{ height: '100%' }}>
                <Col xs={'auto'} className={'my-auto mx-auto'}>
                    <Spinner animation="border">

                    </Spinner>
                </Col>
            </Row>
        </Container>
    </Container>);
}